import { Trans, Select } from '@lingui/macro';
import React, { FC, memo } from 'react';

import { TLatestRequest } from 'Components/LatestRequests/LatestRequests.helpers';
import Image from 'common/Image/Image';
import { LinkButton } from 'uikit/Button';
import { TextMeta } from 'uikit/Text';

type Props = TLatestRequest & {
  onDetailsClick: (request: TLatestRequest) => void;
};

const RequestCard: FC<Props> = (props) => {
  let gender = '';
  if (props.user.gender === '1') gender = 'male';
  if (props.user.gender === '2') gender = 'female';

  return (
    <div className="latestRequests__item">
      <div className="latestRequests__user">
        <Image src={props.user.avatar} webp multiPixelRatios size="s" alt="" className="latestRequests__userAvatar" />
        <TextMeta big bold>
          <Select
            value={gender}
            male={`${props.user.name} dodał zapytanie`}
            female={`${props.user.name} dodała zapytanie`}
            other=""
          />
        </TextMeta>
      </div>
      <div className="latestRequests__row">
        <TextMeta big light>
          <Trans>Usługa</Trans>:
        </TextMeta>
        {props.l4Category?.name && (
          <TextMeta big bold>
            {props.l4Category.name}
          </TextMeta>
        )}
      </div>
      {props.details.slice(0, 2).map((detail, index) => (
        <div className="latestRequests__row" key={`question-${detail.question_id}-${index}`}>
          <TextMeta big light className="latestRequests__answer">
            {detail.question}
          </TextMeta>
          <TextMeta big bold className="latestRequests__answer">
            {detail.answer}
          </TextMeta>
        </div>
      ))}
      <LinkButton onClick={() => props.onDetailsClick(props)} className="latestRequests__more">
        <Trans>Czytaj więcej</Trans>
      </LinkButton>
    </div>
  );
};

export default memo(RequestCard);
